module.exports = __webpack_public_path__ + "static/media/4-desktop.1d490d93.jpg";